// extracted by mini-css-extract-plugin
export default {"titleDiv":"PointsDetail_titleDiv__VHZ3x","title0":"PointsDetail_title0__ABLVY","title1":"PointsDetail_title1__UT-IJ"};